import React from 'react'
import { graphql } from 'gatsby'
import Img, { GatsbyImageProps } from 'gatsby-image'

import { SEO } from '../components/SEO'
import { Layout } from '../components/Layout'
import { Container } from '../components/Container'
import { Markdown } from '../components/Markdown'

import { Person as PersonInterface } from '../interfaces'

interface ExtendedPersonInterface extends PersonInterface {
  picture: GatsbyImageProps
}

interface Props {
  data: {
    person: ExtendedPersonInterface
  }
}

function Person(props: Props) {
  const { person } = props.data

  return (
    <Layout spaceTop={true}>
      <SEO title={`${person.title} ${person.name}`} />

      <Container>
        <h1 className="font-serif text-3xl text-gray-700 pb-3">{`${person.title} ${person.name}`}</h1>
        <hr />

        <section className="pt-8">
          <div className="md:flex">
            <figure className="w-full max-w-md md:pr-8 mb-5 md:mb-0">
              <Img fluid={person.picture.fluid} />
            </figure>

            <div className="w-full max-w-lg md:pl-8">
              <Markdown source={person.about} className="c-markdown" />

              <div className="py-8 md:pt-12">
                <ul className="text-sm">
                  {person.phoneNumbers.map((number, idx) => (
                    <li key={idx}>{number}</li>
                  ))}
                  <li>
                    <a href={`mailto:${person.email}`} className="text-blue-600 hover:underline">
                      {person.email}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </Container>
    </Layout>
  )
}

export default Person

export const query = graphql`
  query($slug: String!) {
    person: datoCmsPerson(slug: { eq: $slug }) {
      name
      title
      about
      phoneNumbers
      email
      picture {
        fluid(maxWidth: 400) {
          ...GatsbyDatoCmsFluid
        }
      }
    }
  }
`
